import React, { useEffect, useState } from 'react';
import StoreInfo from './StoreInfo';
import googleImage from './assets/googlemaps.png';
import logo from './assets/logo.webp'; // ajuste le chemin selon ton projet

export default function Home() {
  const REMISE_CSE = 0.05; // 5% de remise (tu peux changer à 0.10 pour 10%)
  const [products, setProducts] = useState([]);
  const [client, setClient] = useState({ nom: '', prenom: '', email: '', telephone: '', paiement: '' , comment: '', codeCse: '' });
  const [testingMode, setTestingMode] = useState(false);
  const [envoyerMail, setEnvoyerMail] = useState(true);
  const [notificationPreference, setNotificationPreference] = useState('');
  const [loading, setLoading] = useState(false);
  // const [successMessage, setSuccessMessage] = useState('');
  const [successData, setSuccessData] = useState(null); // contient les infos pour le message final
  const [selectedImage, setSelectedImage] = useState(null);
  const [codeCse, setcodeCse] = useState('');
  const [iscodeCseValide, setIscodeCseValide] = useState(false);

  useEffect(() => {
    fetch('/api/products')
      .then(res => res.json())
      .then(setProducts);
  }, []);

  useEffect(() => {
    setIscodeCseValide(client.codeCse.trim().toLowerCase() === 'cse-scapest');
  }, [client.codeCse]);

  const formatNom = (nom) => nom.toUpperCase();

  const formatPrenom = (prenom) => {
    if (!prenom) return '';
    return prenom.charAt(0).toUpperCase() + prenom.slice(1).toLowerCase();
  };

  const handleChange = (index, value) => {
    const newProducts = [...products];
    newProducts[index].quantite = Number(value);
    setProducts(newProducts);
  };

  const getProductImage = (product) => {
    const productImagePath = `/images/${product.id}.jpg`;
    const fallbackIconPath = `/icons/${product.category.toLowerCase()}.png`;

    // On vérifie si l'image produit existe avec une "test image" :
    const img = new Image();
    img.src = productImagePath;

    // JS ne permet pas de vérifier l'existence d'une image sans l'afficher ou attendre un "onerror",
    // donc ici on précharge à l'avance si besoin, ou sinon on accepte une "erreur visuelle tolérée".
    return img.complete !== 0 ? productImagePath : fallbackIconPath;
  };

  const rawTotal = products.reduce((acc, p) => acc + (p.quantite || 0) * p.prix, 0);
  const total = iscodeCseValide ? rawTotal * (1 - REMISE_CSE) : rawTotal;

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const produits = products.filter(p => p.quantite > 0);

    if (produits.length === 0) return alert('Veuillez sélectionner au moins un article.');
    if (!client.paiement) return alert('Veuillez choisir un mode de paiement.');
    if (!iscodeCseValide) return alert('Veuillez entrer un code CSE valide pour valider la commande.');
    
    // Validation spécifique pour "magasin"
    // if (client.paiement === 'magasin' && !notificationPreference) {
    //   return alert('Veuillez choisir une préférence de notification (par téléphone ou par mail).');
    // }

    setLoading(true);
    // setSuccessMessage('');
    setSuccessData(null);


    try {
      const res = await fetch('/api/submit-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...client, produits, paiement: client.paiement, envoyerMail, testingMode: testingMode, notificationPreference, total: total, totalAvantRemise: rawTotal })
      });

      const data = await res.json();

      if (data.success && data.lienTelechargement) {
        const a = document.createElement('a');
        a.href = data.lienTelechargement;
        a.download = '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Stocker infos pour affichage JSX
        setSuccessData({
          testingMode,
          envoyerMail,
          lien: data.lienTelechargement,
        });

        // setSuccessMessage(
        //   `✅ Votre commande a bien été envoyée !\n` +
        //   (envoyerMail
        //     ? '📧 Un email de confirmation vous a été envoyé (PDF joint).\n'
        //     : '📭 Vous avez choisi de ne pas recevoir de mail.\n') +
        //   '📄 Le récapitulatif PDF est en cours de téléchargement.'
        // );

        // RESET FORMULAIRE ET QUANTITÉS PRODUITS
        setClient({ nom: '', prenom: '', email: '', telephone: '', paiement: '' , comment: '', codeCse: '' });
        setEnvoyerMail(true);
        setTestingMode(false);
        setNotificationPreference('');
        setProducts(products.map(p => ({ ...p, quantite: 0 })));
      } else {
        alert('Commande envoyée, mais une erreur est survenue lors de la génération du PDF.');
      }
    } catch (err) {
      console.error('Erreur:', err);
      alert('Erreur lors de l’envoi de la commande. Veuillez réessayer plus tard.');
    } finally {
      setLoading(false);
    }
  };

  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      {/* Ajout des styles CSS pour la responsivité */}
      <style>{`
        @media (max-width: 1024px) {
          .container-flex {
            flex-direction: column !important;
          }
          .form-column, .table-column {
            width: 100% !important;
            max-height: none !important;
          }
          th, td {
            text-align: center;
            padding: 2px 2px;
            border-bottom: 1px solid #ddd;
            font-size: 0.7rem;
          }
          input {
            width: 20px;
          }
          .header-responsive {
            flex-direction: column;
            text-align: center;
            padding: 2vh;
          }
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    
      <style>{`
        input:required {
          border-left: 5px solid #ff9800;
          background-color: #fffef2;
        }

        input:invalid:focus {
          border: 2px solid red;
        }

        input:valid:focus {
          border: 2px solid green;
        }
      `}</style>

      <div style={{ backgroundColor: '#f8f4e3', padding: '10px', textAlign: 'center', color: '#b33', fontWeight: 'bold' }}>
        ⚠️ Ce site est actuellement réservé aux salariés des Comités d'Entreprise (CSE) en partenariat.
        {/* <br /> */}
        {/* 👉 Vous êtes une entreprise ou un CSE intéressé ? <a href="mailto:partenariat@auplaisirgourmand51.fr" style={{ color: '#b33', textDecoration: 'underline' }}>Contactez-nous</a> */}
      </div>

      <div className='header-responsive' style={{ display: 'flex', alignItems: 'center', gap: '20px', background: 'linear-gradient(90deg,rgba(185, 209, 107, 1) 0%, rgba(200, 214, 104, 1) 47%, rgba(182, 212, 87, 1) 79%, rgba(148, 194, 76, 1) 92%)', marginBottom: '5vh'}}>
        {/* Logo à gauche */}
        <a href="/">
          <img src={logo} alt="Logo" style={{ height: '100px', marginLeft: '10px' }} />
        </a>

        {/* Titre + message à droite */}
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <h1 style={{ margin: '0 0 1vh 0' }}>Au Plaisir Gourmand - Formulaire de commande</h1>
          <p style={{ fontWeight: 'bold', color: '#624512', marginTop: '10px', lineHeight: '2em' }}>
            🎁 Grâce au CSE, profitez de tarifs préférentiels et récupérez vos commandes sans frais supplémentaires.
            <br />
            🎁 La remise sera effective sur la totalité de votre commande et affichée dans votre panier et sur la facture après que vous ayez renseigné votre code CSE (offre non cumulable avec la carte fidélité).
            <br />
            🔔 Commande prête sous 48h, jusqu'à 15 jours si un de nos produits est victime de son succès ! :)

          </p>
        </div>
      </div>

      {/* {successMessage && (
        <div style={successBoxStyle}>
          {successMessage.split('\n').map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
      )} */}

      <div className="container-flex" style={{ display: 'flex', gap: '20px', padding: '0 20px' }}>
        {/* Colonne gauche (formulaire) */}
        <div className="form-column" style={{ width: '35%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Formulaire et total */}
          <div className="lien-produits-responsive" style={{ marginBottom: '10px' }}>
            <a href="#produits" style={{ color: '#357ABD', fontWeight: 'bold', textDecoration: 'underline' }}>
              📦 Accéder aux produits
            </a>
          </div>

          <div style={{ backgroundColor: '#f9f9f9', padding: 15, borderRadius: 8, boxShadow: '8px -10px 11px rgba(0,0,0,0.1)', border: '6px solid #C8D668' }}>
          <h2>
            Total :
            {rawTotal > 0 && iscodeCseValide ? (
              <> <s>{rawTotal.toFixed(2)}€</s> {total.toFixed(2)}€ TTC (remise {Math.round(REMISE_CSE * 100)}%)</>
            ) : (
              <> {total.toFixed(2)}€ TTC</>
            )}
          </h2>
          
          {products.some(p => p.quantite > 0) && (
            <div style={{ marginBottom: '20px', background: '#fffced', border: '1px solid #f0e6c0', padding: '10px', borderRadius: '8px' }}>
              <h3 style={{ marginBottom: '10px' }}>🧺 Récapitulatif de votre panier :</h3>
              <ul style={{ paddingLeft: '20px', margin: 0 }}>
                {products
                  .filter(p => p.quantite > 0)
                  .map(p => (
                    <li key={p.id}>
                      {p.quantite} × <strong>{p.nom}</strong> ({p.prix.toFixed(2)}€ / unité) → {(p.prix * p.quantite).toFixed(2)}€
                    </li>
                  ))}
              </ul>
            </div>
          )}

            <h3>Informations client</h3>
            <form onSubmit={handleSubmit}>
              <input placeholder="Nom*" required value={client.nom} onChange={e => setClient({ ...client, nom: formatNom(e.target.value) })} style={inputStyle} />
              <input placeholder="Prénom*" required value={client.prenom} onChange={e => setClient({ ...client, prenom: formatPrenom(e.target.value) })} style={inputStyle} />
              <input placeholder="Email*" required type="email" value={client.email} onChange={e => setClient({ ...client, email: e.target.value })} style={inputStyle} />
              <input
                placeholder="Téléphone (facultatif)"
                type="tel"
                pattern="^0[1-9][0-9]{8}$"
                title="Le numéro doit contenir exactement 10 chiffres et commencer par 0 (ex: 0612345678)"
                value={client.telephone}
                onChange={e => setClient({ ...client, telephone: e.target.value })}
                style={inputStyle}
              />
              <input placeholder="Commentaire (facultatif)" type="comment" value={client.comment} onChange={e => setClient({ ...client, comment: e.target.value })} style={inputStyle} />
              <input
                placeholder="Code CSE* (requis pour valider la commande)"
                value={client.codeCse}
                onChange={e => setClient({ ...client, codeCse: e.target.value.toLowerCase() })}
                required
                style={inputStyle}
              />

              {/* {!iscodeCseValide && codeCse && (
                <p style={{ color: 'red', fontSize: '0.9em' }}>⛔ Code CSE invalide. Veuillez entrer un code valide.</p>
              )} */}

              <div style={{ margin: '10px 0' }}>
                {/* <div style={{ display: 'none' }}>
                  <label>
                    <input type="checkbox" checked={!envoyerMail} onChange={() => setEnvoyerMail(prev => !prev)} /> Ne pas m'envoyer de confirmation par mail
                  </label> <br /><br />
                </div> */}
                <label>
                  <input type="radio" name="paiement" value="cse" onChange={e => setClient({ ...client, paiement: e.target.value })} />
                  Retrait et paiement via le CSE (chèque uniquement)
                </label><br />
                <label>
                  <input type="radio" name="paiement" value="magasin" onChange={e => setClient({ ...client, paiement: e.target.value })} />
                  Retrait et paiement directement en magasin (chèque/espèces/carte)
                </label>
              </div>

              {client.paiement === 'cse' && (
                <p style={{ fontSize: '0.9em', color: '#555' }}>
                  → Paiement par chèque uniquement (à l'ordre de : Au Plaisir Gourmand) : le CSE vous préviendra de la disponibilité de votre commande directement par mail.
                </p>
              )}
              {client.paiement === 'magasin' && (
                <p style={{ fontSize: '0.9em', color: '#555' }}>
                  → Paiement par chèque/espèces/carte : vous serez prévenus de la disponibilité de votre commande directement par mail.
                </p>
              )}

              {/* {(client.paiement === 'magasin') && (
                <div style={{ marginTop: 10 }}>
                  <label>Préférence de notification :</label><br />
                  <label>
                    <input
                      type="radio"
                      name="notification"
                      value="telephone"
                      checked={notificationPreference === 'telephone'}
                      onChange={e => setNotificationPreference(e.target.value)}
                    /> Par téléphone
                  </label><br />
                  <label>
                    <input
                      type="radio"
                      name="notification"
                      value="mail"
                      checked={notificationPreference === 'mail'}
                      onChange={e => setNotificationPreference(e.target.value)}
                    /> Par mail
                  </label>
                  <br />
                  <br />
                </div>
              )} */}

              <button type="submit" disabled={loading}>
                {loading ? 'Envoi en cours...' : 'Valider la commande'}
              </button>
            </form>

            {/* Affichage du message de confirmation */}
            {successData && (
              <div style={{
                backgroundColor: '#d4edda', // vert clair
                border: '1px solid #c3e6cb', // vert bordure
                color: '#155724', // texte vert foncé
                padding: '15px',
                borderRadius: '6px',
                marginTop: '1rem',
                whiteSpace: 'normal',
              }}>
                <p>✅ Votre commande a bien été envoyée !</p>
                <p>
                  {successData.envoyerMail ? (
                    <>
                      📧 Un email de confirmation vous a été envoyé (PDF joint).
                    </>
                  ) : (
                    <>📭 Vous avez choisi de ne pas recevoir de mail.</>
                  )}
                </p>
                <p>
                  📄 Le récapitulatif PDF est en cours de téléchargement, et est
                  disponible{' '}
                  <a
                    href={successData.lien}
                    className="underline text-blue-600"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ici
                  </a>
                  .
                </p>
              </div>
            )}
          </div>

          {/* Infos magasin */}
          <div style={infoBoxStyle}><StoreInfo /></div>

          {/* Google Maps */}
          <div style={infoBoxStyle}>
            <a href="https://www.google.com/maps/place/Au+plaisir+gourmand/@48.9554779,4.3613644,18z" target="_blank" rel="noopener noreferrer">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3063.3672579428207!2d4.35943317647003!3d48.95547787134544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47ebe08168a05f79%3A0x11f5c0727855eb0a!2s16%20Pl.%20de%20la%20R%C3%A9publique%2C%2051000%20Ch%C3%A2lons-en-Champagne!5e1!3m2!1sen!2sfr!4v1750180788396!5m2!1sen!2sfr" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </a>
          </div>
        </div>

        {/* Colonne droite (tableau produits) */}
        <div id="produits" className="table-column" style={{ width: '65%', maxHeight: '80vh', overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              {(() => {
                let globalIndex = 0;
                return [...new Set(products.map(p => p.category))].sort().map(category => {
                  const categoryProducts = products
                    .filter(p => p.category === category)
                    .sort((a, b) => a.id - b.id); // ou .sort((a, b) => a.nom.localeCompare(b.nom)) si besoin
                  
                  const totalQty = categoryProducts.length;

                  return (
                    <React.Fragment key={category}>
                      <tr>
                        <td colSpan="7" style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>
                          <details open>
                            <summary style={{ cursor: 'pointer', fontSize: '1.1em' }}>
                              {category} ({totalQty} article proposé{totalQty > 1 ? 's' : ''})
                            </summary>

                            <table
                              style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginTop: 5,
                                tableLayout: 'fixed',
                              }}
                              border="1"
                              cellPadding="5"
                            >
                              <colgroup>
                                <col style={{ width: '10%' }} /> {/* Image */}
                                <col style={{ width: '5%' }} /> {/* ID */}
                                {/* <col style={{ width: '15%' }} /> */}
                                <col style={{ width: '40%' }} />
                                <col style={{ width: '10%' }} />
                                <col style={{ width: '10%' }} />
                                <col style={{ width: '10%' }} />
                                <col style={{ width: '10%' }} />
                              </colgroup>
                              <thead style={{ backgroundColor: '#BEE055', color: '#333333' }}>
                                <tr>
                                  <th>Photo</th> {/* Nouvelle colonne image */}
                                  <th>ID</th>
                                  {/* <th>Catégorie</th> */}
                                  <th>Produit</th>
                                  <th>Poids</th>
                                  <th>Prix (TTC)</th>
                                  <th>Quantité</th>
                                  <th>Total (TTC)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {categoryProducts.map((p) => (
                                  <tr key={p.id}>
                                    <td>
                                      <img
                                        className="product-image"
                                        src={getProductImage(p)}
                                        alt={p.nom}
                                        onClick={() => setSelectedImage(getProductImage(p))}
                                      />
                                        {/* // onError={(e) => { e.target.src = `/icons/${p.category.toLowerCase()}.png`; }} */}
                                    </td>
                                    <td>{++globalIndex}</td>
                                    {/* <td style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>{p.category}</td> */}
                                    <td style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                      {p.nom}
                                      {p.comment !== "" && (
                                        <div style={{ fontStyle: 'italic', color: 'gray' }}>
                                          {p.comment}
                                        </div>
                                      )}
                                    </td>
                                    {/* <td style={{ wordWrap: 'break-word', whiteSpace: 'normal', textAlign: 'left' }}>{p.category} - {p.nom}</td> */}
                                    <td style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>{capitalizeFirstLetter(p.definition)}</td>
                                    <td>{p.prix.toFixed(2)}€</td>
                                    <td>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <input
                                          type="number"
                                          min="0"
                                          value={p.quantite || ''}
                                          onChange={e =>
                                            handleChange(products.findIndex(prod => prod.id === p.id), e.target.value)
                                          }
                                          style={qtyInputStyle}
                                        />
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                          <button
                                            type="button"
                                            onClick={() => {
                                              const index = products.findIndex(prod => prod.id === p.id);
                                              handleChange(index, (p.quantite || 0) + 1);
                                            }}
                                            style={qtyBtnStyle}
                                          >+</button>
                                          <button
                                            type="button"
                                            onClick={() => {
                                              const index = products.findIndex(prod => prod.id === p.id);
                                              const newQty = Math.max((p.quantite || 0) - 1, 0);
                                              handleChange(index, newQty);
                                            }}
                                            style={qtyBtnStyle}
                                          >−</button>
                                        </div>
                                      </div>
                                    </td>
                                    <td>{((p.quantite || 0) * p.prix).toFixed(2)}€</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </details>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                });
              })()}
            </tbody>

          </table>
        </div>
      </div>
      
      {selectedImage && (
        <div
          onClick={() => setSelectedImage(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <img
            src={selectedImage}
            alt="Agrandie"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              borderRadius: 8,
              boxShadow: '0 0 20px rgba(0,0,0,0.5)',
            }}
          />
        </div>
      )}

      {/* Spinner overlay */}
      {loading && (
        <div style={loaderOverlayStyle}>
          <div style={loaderStyle}></div>
          <p style={{ fontSize: '1.2em', color: '#007bff', fontWeight: 'bold', marginTop: 10 }}>
            Validation de la commande en cours...
          </p>
        </div>
      )}

      {/* Animation keyframes injection */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

    {showScrollTop && (
      <button
        onClick={scrollToTop}
        style={{
          position: 'fixed',
          bottom: 30,
          right: 30,
          padding: '10px 15px',
          fontSize: '16px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
          cursor: 'pointer',
          zIndex: 1000
        }}
        title="Retour en haut"
      >
        🢁
      </button>
    )}

    </div>
  );
}

// STYLES

const inputStyle = {
  width: '96%', margin: '0 10px 8px 0', padding: 6,
  borderRadius: 4, border: '1px solid #ccc'
};

const buttonStyle = {
  padding: '10px 20px', backgroundColor: '#007bff', color: '#fff',
  border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 'bold'
};

const infoBoxStyle = {
  padding: 15, borderRadius: 8,
  boxShadow: '0 0 10px rgba(0,0,0,0.1)',
  backgroundColor: '#fff',
  boxShadow: '8px -10px 11px rgba(0,0,0,0.1)',
  border: '6px solid #C8D668' 
};

const qtyBtnStyle = {
  width: 24,
  height: 24,
  padding: 0,
  margin: 0,
  backgroundColor: '#BEE055',
  color: '#333333',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  userSelect: 'none',
  fontWeight: 'bold',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  lineHeight: 1,
};

const loaderOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(255,255,255,0.85)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999
};

const loaderStyle = {
  border: '8px solid #f3f3f3',
  borderTop: '8px solid #007bff',
  borderRadius: '50%',
  width: 60,
  height: 60,
  animation: 'spin 1s linear infinite'
};

const qtyInputStyle = {
  width: 30,
  padding: 4,
  borderRadius: 4,
  border: '1px solid #ccc',
  textAlign: 'center',
};

const thStyle = {
  padding: '8px',
  textAlign: 'left',
  borderBottom: '2px solid #ccc'
};

const tdStyle = {
  padding: '8px',
  textAlign: 'left'
};

const successBoxStyle = {
  backgroundColor: '#d4edda',
  border: '1px solid #c3e6cb',
  color: '#155724',
  padding: '15px',
  borderRadius: '6px',
  marginBottom: '20px',
  whiteSpace: 'pre-line', // pour respecter les sauts de ligne
};

// obliger numéro à 10 chiffres
// mettre en avant les champs requis
